<template>
    <div v-if="ui.ringLoader" class="background"></div>
    <div v-if="ui.ringLoader" class="lds-dual-ring"></div>
</template>
  
<script>
    import { useUI } from "@/store/ui";
  
    export default {
    
        setup() {
            return {
                ui: useUI()
            }
        },
    
    }
</script>
  
<style lang="scss" loader>
    @import "@/assets/css/vars.scss";

    .background {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 900;
        background: rgba(0, 0, 0, 0.3);
    }

    .lds-dual-ring {

        display: inline-block;
        width: 80px;
        height: 80px;
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1000;
    
        &:after {
            content: " ";
            display: block;
            width: 64px;
            height: 64px;
            margin: 8px;
            border-radius: 50%;
            border: 6px solid white;
            border-color: $brand_primary transparent $brand_secondary transparent;
            animation: lds-dual-ring 1.6s linear infinite;
        }
    }
    
    @keyframes lds-dual-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
  
</style>